// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   Tooltip,
//   CartesianGrid,
//   ResponsiveContainer,
// } from 'recharts';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from 'recharts';

const StatisticChart = ({ data }) => {
  const customLegend = (value, entry) => {
    const { color } = entry;
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
        }}
      >
        <svg width="12" height="12">
          <circle cx="6" cy="6" r="4" fill={color} />
          {/* Or any custom SVG shape */}
        </svg>
        <span style={{ color: '#6D758F' }}>{value}</span>
      </div>
    );
  };
  return (
    <div style={{ width: '100%', height: 'auto' }}>
      <AreaChart
        style={{
          width: '100%',
          maxHeight: '400px',
          aspectRatio: 1.618,
        }}
        responsive
        data={data}
        margin={{
          top: 20,
          right: 0,
          left: 0,
          bottom: 0,
        }}
      >
        <CartesianGrid stroke="#efefefff" strokeSolidarray="2 2" />
        <Legend
          formatter={customLegend}
          verticalAlign="top"
          align="right"
          // wrapperStyle={{ marginBottom: '-20px' }}
        />
        <XAxis dataKey="month" tickLine={false} />
        <YAxis width="100%" tickLine={false} />
        {/* <Tooltip /> */}
        <Area
          name="Broj prodatih proizvoda"
          type="monotone"
          dataKey="purchased"
          stroke="#005844"
          fill="#b8d9bc5d"
          strokeWidth={2}
        />
        <Area
          name="Iskorišćeni vaučeri"
          type="monotone"
          dataKey="vouchers"
          stroke="#B8D9BC"
          fill="#b8d9bc45"
          strokeWidth={2}
        />
      </AreaChart>
      {/* <ResponsiveContainer>
        <LineChart
          data={data}
          margin={{ top: 20, right: 25, bottom: 140, left: 0 }}
        >
          <CartesianGrid stroke="#efefefff" strokeSolidarray="2 2" />
          <XAxis dataKey="month" />
          <YAxis />
          <Tooltip
          // formatter={customTooltipFormatter}
          // labelFormatter={(label) => `Year: ${label}`}
          />
          <Line
            type="monotone"
            dataKey="purchased"
            name="Purchased"
            stroke="#005844"
            strokeWidth={2}
            // dot
          />
          <Line
            type="monotone"
            dataKey="vouchers"
            name={`Vouchers`}
            stroke="#B8D9BC"
            strokeWidth={2}
            // dot
          />
        </LineChart>
      </ResponsiveContainer> */}
    </div>
  );
};
export default StatisticChart;
